import { get } from 'lodash'

import { GridColumn, GridItem } from '@types'
import { Entity } from '@/entities/utils/common'

import { exportCSV } from '@/helpers/common'

export const useGridCheckedExport = (
  columns: GridColumn[],
  items: GridItem[],
  ids: string[],
  fileName: string,
  unwrapped = false
) => {
  const exportData = items.filter(item => ids.includes(item.id))
  useHandledGridExport(columns, exportData, fileName, unwrapped)
}

export const useHandledGridExport = (
  columns: GridColumn[],
  items: GridItem[],
  fileName: string,
  unwrapped = false,
) => {
  const fields = columns.filter(column => !column.hidden).map(column => column.caption)
  const data: string[][] = []
  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    const row = []
    for (let j = 0; j < columns.length; j++) {
      const column = columns[j]
      const value = unwrapped
        ? get(item, column.name.split('.'))
        : item.field(column.name as keyof Entity<any>).value
      row.push(column.formatter ? column.formatter(value, item) : value)
    }
    data.push(row)
  }
  exportCSV(fileName, fields, data)
}
